import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X } from "lucide-react";

const POSTER = "/assets/video/gary-portrait-crop.jpg";
const SRC = "/assets/video/gary-hero-720.mp4";

export const HeroVideo = () => {
  const [full, setFull] = useState(false);
  const videoRef = useRef(null);

  const openFull = () => {
    setFull(true);
    setTimeout(() => { if (videoRef.current) { videoRef.current.currentTime = 0; videoRef.current.play().catch(() => {}); } }, 120);
  };
  const closeFull = () => { if (videoRef.current) videoRef.current.pause(); setFull(false); };

  return (
    <>
      <motion.div
        data-testid="hero-video-card"
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        className="relative group cursor-pointer rounded-2xl overflow-hidden ring-gold-frame"
        onClick={openFull}
      >
        <div className="absolute -inset-6 radial-glow blur-2xl pointer-events-none" />
        <div className="relative aspect-[4/5] sm:aspect-[16/12] bg-[#0B1020]">
          <img loading="lazy" src={POSTER} alt="Gary Malkin" className="absolute inset-0 w-full h-full object-cover object-[50%_18%] opacity-90 group-hover:opacity-100 group-hover:scale-[1.03] transition-all duration-700"
               onError={(e) => { e.currentTarget.style.display = "none"; }} />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080B12] via-transparent to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-20 h-20 rounded-full btn-gold flex items-center justify-center animate-pulse-glow shrink-0">
                <Play size={30} className="ml-1 text-[#14100A]" fill="#14100A" />
              </div>
              <span className="text-cream/90 text-sm tracking-[0.2em] uppercase">Experience the Vision</span>
            </div>
            <div className="gold-hairline mb-3" />
            <p className="text-cream/80 text-sm md:text-[15px] leading-snug max-w-md">
              A three-minute reflection on music, resonance, and awakening the deeper capacities that make us human.
            </p>
          </div>
        </div>
      </motion.div>

      <AnimatePresence>
        {full && (
          <motion.div
            data-testid="hero-video-fullscreen"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4"
            onClick={closeFull}
          >
            <button data-testid="hero-video-close" className="absolute top-6 right-6 text-cream/80 hover:text-[#E7CC86] transition-colors" onClick={closeFull}>
              <X size={34} />
            </button>
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="w-full max-w-5xl rounded-xl overflow-hidden ring-gold-frame"
              onClick={(e) => e.stopPropagation()}
            >
              <video ref={videoRef} src={SRC} poster={POSTER} controls playsInline className="w-full h-auto bg-black" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
